import React, {useState, useEffect } from "react";
import loadingSpin from "../images/loadingSpin.gif";
import AccordionLayout from "./Accordion";
import axios from "axios";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import Card from './common/Card';
import EmptyContent from "../components/common/EmptyContent";


const AccordionMessage = () => {
  const [result, setResult] = useState([])
  const [loading, setLoading] = useState(false);
  const [fetchedNotes, setFetchedNotes] = useState([]);
  const [ fetchError, setFetchError ] = useState(false);

  const studentInfo   =   JSON.parse(localStorage.getItem('studentInfo'));
  const FathersEmail  =   studentInfo[0].FathersEmail;
  const GuardianEmail =   studentInfo[0].GuardianEmail;
  const parentemail   =   studentInfo[0].parentemail;
  
  const MotherEmail   =   studentInfo[0].MotherEmail;
  // const idx = JSON.parse(localStorage.getItem('subSchoolData')).idx;
  // const FathersEmail = JSON.parse(localStorage.getItem('studentInfo')).FathersEmail;
  // const GuardianEmail  = JSON.parse(localStorage.getItem('studentInfo')).GuardianEmail
  // const parentemail = JSON.parse(localStorage.getItem('FathersEmail'))

  const schoolDomain = localStorage.getItem('schoolDomain');
  
  useEffect(() => {
    let Params = {
      "SchoolUrl": schoolDomain,
      "parentEmail": {
          "parentEmail": parentemail,
          "fatherEmail":  FathersEmail,
          "motherEmail": MotherEmail,
          "guardianEmail": GuardianEmail,
      },
      "schDeploymentid": 1,
    };

      setLoading(true)
    axios
      .post(
        "https://devapi.edves.net/testapi/public/v1/communication",
        JSON.stringify(Params),  
      )
      .then(
        (response) => {
          setLoading(false)
          setResult(response.data.data)
          response.data.data.length > 0 && setFetchedNotes(response.data.data[0].Available_Notes);
        },
        (error) => {
          console.log(error);
          setFetchError(true);
        }
      );
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
    {
        loading ? 
        <div className='flex justify-center w-full h-full my-24'>
            <img src={loadingSpin} alt='loading...' />
        </div> 
  :
  <Card>
     {
      fetchedNotes && fetchedNotes.length === 0 && !loading && !fetchError ?
                   <div className='flex justify-center w-full sm:mt-16'>
              <EmptyContent message='No Communication Found' moreMessage='Communication made will be displayed here' />
                 </div> :
                    result.map((item,index)=>{
                      return (
                      <AccordionLayout 
                      title={item.messagesubject}
                      index={index+1}
                      key={index+1}
                      activeIndex={activeIndex}
                      setActiveIndex={setActiveIndex}
                      >
                      
                      <span>Subject Message </span>
                      <iframe style={{height: "500px", width: "500px"}} sandbox='' srcDoc={item.message} />
                       <br></br>
                       <br></br>
                       <span>Type of Message: </span> {item.type} 
                       <br></br>
                       <br></br>
                       <span>Date: </span> {item.timestp} 
                      </AccordionLayout>
                      )
                    })
                  }
            
                  </Card>
                  }   
    </>
  );
};

export default AccordionMessage;
